import { AttachmentItemController } from './attachment-item.controller'

const component = {
  templateUrl: '/workflow/components/attachment-item/attachment-item.html?$$REVISION$$',
  bindings: {
    attachment: '<',
    mActions: '<',
    readOnly: '<',
    slider: '<',
    changeVisibility: '<',
    hideInformation: '<',
    location: '<'
  },
  controllerAs: '$ctrl',
  controller: AttachmentItemController
}

export const attachmentItem = component
